// removed by extract-text-webpack-plugin
module.exports = {"block":"Feedback_block_1c3TY","link":"Feedback_link_vgj2O"};